import {
  type CatalogItem,
  type EditCatalogItemSubmission,
} from '@webapp/models'
import { ApiClient } from '@webapp/services/api'

export const ENDPOINT = '/api/v3/catalog-items/'
export const CATALOG_ITEMS_URL = ENDPOINT

export const EXPORT_CATALOG_ITEMS_URL = '/api/v3/catalog-items/export/'
export const IMPORT_CATALOG_ITEMS_URL = `${ENDPOINT}import/`

export const CatalogItemsAPI = {
  editCatalogItem: (
    catalogItemId: CatalogItem['id'],
    catalogItemData: EditCatalogItemSubmission
  ) => {
    return ApiClient.put<EditCatalogItemSubmission, CatalogItem>(
      `${CATALOG_ITEMS_URL}${catalogItemId}/`,
      catalogItemData
    )
  },
}
